import React from 'react'

import { HeadContent, Subsection } from '@fourthwall/components'

import type { ConnectedSitesListProps } from './components/ConnectedSitesList/ConnectedSitesList'
import { ConnectedSitesList } from './components/ConnectedSitesList/ConnectedSitesList'

export type ConnectedSitesViewProps = {
  items: ConnectedSitesListProps['items'] | undefined
}

export const CONNECTED_SITES_TITLE = 'Connected sites'

export const ConnectedSitesView = ({ items = [] }: ConnectedSitesViewProps) => (
  <>
    <HeadContent title={`${CONNECTED_SITES_TITLE} \u2013 Account settings`} />
    <Subsection title={CONNECTED_SITES_TITLE}>
      {!!items.length && (
        <div style={{ marginTop: -12 - 4 }}>
          <ConnectedSitesList items={items} />
        </div>
      )}
    </Subsection>
  </>
)
